import { useCallback } from "react";
import { InstrumentRedirectInput } from "@helpers";
import { useMandatorLinks } from "./useMandatorLinks";

export const useInstrumentUrl = () => {
  const { getInstrumentDetailUrl } = useMandatorLinks();

  return useCallback(
    (input: InstrumentRedirectInput): string | undefined =>
      getInstrumentDetailUrl?.(input) ?? undefined,
    [getInstrumentDetailUrl]
  );
};
